/* eslint-disable react-hooks/exhaustive-deps */
import { useRef, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Box, CircularProgress } from '@mui/material';

import { useFilePreviewDialog } from 'contexts/FilePreviewDialogContext';
import { downloadFileData } from 'store/slices/files';

export const VideoViewer = ({ file = {} }) => {
  const dispatch = useDispatch();
  const videoRef = useRef(null);

  const [isLoading, setIsLoading] = useState(false);

  const { setFileBlobUrl } = useFilePreviewDialog();

  useEffect(() => {
    if (file.oid && !file?.blobUrl) {
      setIsLoading(true);
      dispatch(downloadFileData({ id: file.oid }))
        .unwrap()
        .then(async (data) => {
          setFileBlobUrl(file.id, data);
          setIsLoading(false);
        })
        .catch(() => {
          setIsLoading(false);
        });
    }
  }, [file.oid, dispatch]);

  return (
    <Box
      sx={{
        position: 'relative',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        maxWidth: '70%',
        maxHeight: '70%',
        margin: 'auto',
      }}
    >
      {isLoading && (
        <CircularProgress
          size={24}
          sx={{
            position: 'absolute',
            zIndex: 2,
          }}
        />
      )}
      {file?.blobUrl && !isLoading && (
        <video
          ref={videoRef}
          style={{ width: '100%', maxHeight: '80vh', borderRadius: '8px' }}
          controls
        >
          <source
            src={file.blobUrl}
            type="video/mp4"
            height="100%"
            width="100%"
          />
          Your browser does not support the video tag.
        </video>
      )}
    </Box>
  );
};
